import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { CSSProperties } from "react";
import { Token } from "../theme";

export interface Props {
  label?: string;
  inlineLabel?: boolean;
  value: string;
  options: string[] | undefined;
  setValue: (value: string) => void;
  size: string;
  customStyle?: CSSProperties;
  readonly?: boolean;
  disabled?: boolean;
  name?: string;
  defaultValue?: string;
  className?: string;
}

export const SelectComponent = ({
  className,
  label,
  inlineLabel,
  value,
  options,
  setValue,
  customStyle,
  size,
  readonly,
  disabled,
  name,
  defaultValue,
}: Props) => {
  const menuItems = options!.map((option, index) => (
    <MenuItem key={index} value={option}>
      {option}
    </MenuItem>
  ));

  return (
    <FormControl style={{ minWidth: "10em", marginLeft: "0.5em", ...customStyle }} variant="outlined" size="small">
      {inlineLabel ? (
        <Select
          id="select-label"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          readOnly={readonly}
          disabled={disabled}
          name={name ?? ""}
          defaultValue={defaultValue}
          renderValue={(selected) => (
            <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
              <span style={{ color: Token.textTertiary, fontSize: 12 }}>{label}:</span>
              <span style={{ color: Token.textPrimary, fontWeight: 600 }}>{selected}</span>
            </span>
          )}
        >
          {menuItems}
        </Select>
      ) : (
        <>
          <InputLabel id="select-label">{label || "Option"}</InputLabel>
          <Select
            id="select-label"
            label={label || "Option"}
            value={value}
            onChange={(e) => setValue(e.target.value)}
            readOnly={readonly}
            disabled={disabled}
            name={name ?? ""}
            defaultValue={defaultValue}
          >
            {menuItems}
          </Select>
        </>
      )}
    </FormControl>
  );
};
